import React, { Component } from "react";
import glamorous from "glamorous";
import _ from "lodash";
import {
  Alert,
  Button,
  ControlLabel,
  Form,
  FormGroup,
  FormControl
} from "react-bootstrap";
import ReactTable from "react-table";

import { FlexDiv, FlexColDiv, Section } from "../../styles/container-elements";
import { datatableThStyles, styleify } from "../../styles/table-styles";
import { getColumns } from "./SavedSearchColumns";
import colors from "../../styles/colors";

import Check from "react-icons/lib/fa/check-circle-o";
import RenameSearchModal from "./RenameSearchModal";
import DeleteSearchModal from "./DeleteSearchModal";

const FlexRow = glamorous(FlexDiv)({ width: "100%" });
const FormItem = glamorous(FlexDiv)({ flex: "0 0 50%", marginRight: ".5em" });

const getUser = auth => {
  console.log(auth.getDecodedIdToken());
  return auth.isAuthenticated() ? auth.getDecodedIdToken()["sub"] : "";
};

const FormInput = ({ evt, handler, lbl, placeholder, type = "text", val }) => {
  return (
    <FormGroup>
      <ControlLabel
        style={{
          color: colors.text.GRAY,
          fontSize: "small",
          fontWeight: "normal"
        }}
      >
        {lbl}
      </ControlLabel>
      <FormControl
        onChange={e => handler(e.currentTarget.value, evt)}
        placeholder={placeholder}
        type={type}
        value={val}
      />
    </FormGroup>
  );
};

class ProfileView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pass: "",
      npass: "",
      cpass: "",
      showDeleteSearchModal: false,
      showRenameSearchModal: false
    };

    this.eventHandler = this.eventHandler.bind(this);
    this.isPassLengthValid = this.isPassLengthValid.bind(this);
    this.isPassRegexValid = this.isPassRegexValid.bind(this);
    this.isPassMatchValid = this.isPassMatchValid.bind(this);
  }

  componentDidMount() {
    const { fetchSavedSearches } = this.props;
    fetchSavedSearches();
  }

  componentDidUpdate(prevProps) {
    const { passwordStatus, resetPasswordForm } = this.props;

    if (passwordStatus && passwordStatus !== prevProps.passwordStatus) {
      console.log("password changed or error");
      this.setState({ npass: "", cpass: "" });
      setTimeout(resetPasswordForm, 3000);
    }
  }

  eventHandler(val, type) {
    const { auth, selectSavedSearch, changePassword } = this.props;
    switch (type) {
      case "INPUT_PASS":
        this.setState({ pass: val });
        break;
      case "INPUT_NPASS":
        this.setState({ npass: val });
        break;
      case "INPUT_CPASS":
        this.setState({ cpass: val });
        break;
      case "DELETE":
        selectSavedSearch(val);
        this.setState({ showDeleteSearchModal: true });
        break;
      case "RENAME":
        selectSavedSearch(val);
        this.setState({ showRenameSearchModal: true });
        break;
      case "CHANGE_PASS":
        let payload = {
          password: val
        };
        changePassword(payload, getUser(auth));
        break;
      default:
        break;
    }
  }

  isPassLengthValid(pass) {
    return _.size(pass) >= 8;
  }

  isPassRegexValid(pass) {
    return /^(?:(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*)$/.test(pass);
  }

  isPassMatchValid(pass, cpass) {
    return !_.isEmpty(pass) && !_.isEmpty(cpass) ? pass === cpass : false;
  }

  render() {
    const {
      carriers,
      exceptionTypes,
      locations,
      passwordStatus,
      savedSearches,
      shipmentModes,
      statusTypes
    } = this.props;

    const {
      // pass,
      npass,
      cpass,
      showDeleteSearchModal,
      showRenameSearchModal
    } = this.state;

    const columns = getColumns(
      savedSearches,
      this.eventHandler,
      statusTypes,
      exceptionTypes,
      shipmentModes,
      carriers,
      locations
    );

    let passLengthValidationState = this.isPassLengthValid(npass);
    let passRegexValidationState = this.isPassRegexValid(npass);
    let passMatchValidationState = this.isPassMatchValid(npass, cpass);

    return (
      <FlexDiv
        css={{
          position: "relative"
        }}
      >
        <Section
          css={{
            backgroundColor: colors.background.LIGHT_GRAY,
            flex: ".5",
            justifyContent: "flex-start"
          }}
        >
          <FlexColDiv
            css={{
              border: "1px solid white",
              borderRadius: 8,
              margin: "1.75em",
              padding: "1.25em"
            }}
          >
            <glamorous.Div
              css={{
                fontWeight: 400,
                marginBottom: "1em"
              }}
            >
              Change Your Password
            </glamorous.Div>
            <Form>
              {/* <FlexRow>
                <FormItem>
                  <FormInput
                    lbl="Password"
                    val={pass}
                    evt="INPUT_PASS"
                    handler={this.eventHandler}
                    type="password"
                  />
                </FormItem>
              </FlexRow> */}
              <FlexRow>
                <FormItem>
                  <FormInput
                    lbl="New Password"
                    placeholder="New Password"
                    val={npass}
                    evt="INPUT_NPASS"
                    handler={this.eventHandler}
                    type="password"
                  />
                </FormItem>
                <FormItem>
                  <FormInput
                    lbl="Confirm Password"
                    placeholder="Confirm Password"
                    val={cpass}
                    evt="INPUT_CPASS"
                    handler={this.eventHandler}
                    type="password"
                  />
                </FormItem>
              </FlexRow>
            </Form>
            <FlexRow style={{ marginBottom: ".25em" }}>
              <Check
                style={{
                  color: passLengthValidationState
                    ? colors.highlight.GREEN
                    : "#e0e0e0",
                  fontSize: "large"
                }}
              />
              <glamorous.Span style={{ fontSize: "small", marginLeft: ".5em" }}>
                Must be at least 8 characters long.
              </glamorous.Span>
            </FlexRow>
            <FlexRow css={{ marginBottom: ".25em" }}>
              <Check
                style={{
                  color: passRegexValidationState
                    ? colors.highlight.GREEN
                    : "#e0e0e0",
                  fontSize: "large"
                }}
              />
              <glamorous.Span style={{ fontSize: "small", marginLeft: ".5em" }}>
                Must contain 1 lowercase letter, 1 uppercase letter, 1 digit.
              </glamorous.Span>
            </FlexRow>
            <FlexRow css={{ marginBottom: "1em" }}>
              <Check
                style={{
                  color: passMatchValidationState
                    ? colors.highlight.GREEN
                    : "#e0e0e0",
                  fontSize: "large"
                }}
              />
              <glamorous.Span style={{ fontSize: "small", marginLeft: ".5em" }}>
                Passwords match.
              </glamorous.Span>
            </FlexRow>
            <FlexRow
              style={{
                justifyContent: "flex-end"
              }}
            >
              {!passwordStatus ? (
                <Button
                  disabled={
                    !passLengthValidationState ||
                    !passRegexValidationState ||
                    !passMatchValidationState
                  }
                  onClick={() => this.eventHandler(cpass, "CHANGE_PASS")}
                >
                  Change My Password
                </Button>
              ) : null}
              {passwordStatus && passwordStatus === "CHANGED" ? (
                <Alert bsStyle="success" style={{ display: "flex", flex: 1 }}>
                  Your password has been changed.
                </Alert>
              ) : null}
              {passwordStatus && passwordStatus === "ERROR" ? (
                <Alert bsStyle="danger" style={{ display: "flex", flex: 1 }}>
                  Change password failed.
                </Alert>
              ) : null}
            </FlexRow>
          </FlexColDiv>
        </Section>
        <Section
          css={{
            backgroundColor: colors.background.LIGHT_GRAY,
            flex: ".5",
            justifyContent: "flex-start",
            paddingTop: "1.75em",
            paddingRight: "1.75em",
            paddingBottom: "1.75em"
          }}
        >
          <FlexColDiv>
            <glamorous.Div
              css={{
                color: colors.text.GRAY,
                fontSize: "small",
                marginBottom: ".5em"
              }}
            >
              My Saved Searches
            </glamorous.Div>
            <ReactTable
              data={savedSearches}
              columns={columns}
              getTheadThProps={styleify(datatableThStyles)}
            />
          </FlexColDiv>
        </Section>
        <RenameSearchModal
          show={showRenameSearchModal}
          hide={() => this.setState({ showRenameSearchModal: false })}
        />
        <DeleteSearchModal
          show={showDeleteSearchModal}
          hide={() => this.setState({ showDeleteSearchModal: false })}
        />
      </FlexDiv>
    );
  }
}

export default ProfileView;



// WEBPACK FOOTER //
// ./src/modules/profile/ProfileView.js